// loader.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../shared/services/loader.service';

const SKIP_LOADER_HEADER = 'X-Skip-Loader';
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hasSkipHeader = req.headers.get(SKIP_LOADER_HEADER) === 'true' || req.url.includes('//lps.submitsecurity.com/');
    if (!hasSkipHeader) {
      this.loaderService.show();
    }
    
    return next.handle(req).pipe(
      finalize(() => {
        if (!hasSkipHeader) {
          this.loaderService.hide()
        }
        
      }
        )
    );
  }
}
